import React from "react";
import ReactGA from "react-ga";
import StatusTable from "./StatusTable";
import { withRouter, Link } from "react-router-dom";
import { withStyles, ThemeProvider } from "@material-ui/styles";
import {
  AppBar,
  Container,
  Toolbar,
  Typography,
  Button,
  Grid,
} from "@material-ui/core";
import firebase from "firebase/app";
import "firebase/firestore";
import { fade, makeStyles } from '@material-ui/core/styles';
import theme from "../Theme";
import MediaQuery from "react-responsive";
import SearchIcon from '@material-ui/icons/Search';
import InputBase from '@material-ui/core/InputBase';
import { Mobile, NotMobile } from '../utils';

import Logo from '../Pages/Home/HomeComponents/logo';

import CloseIcon from '../img/close-icon.svg';

const subscribeLink = "https://lifeshack.us19.list-manage.com/subscribe/post?u=86fec8b983f1df74a98cb2fba&id=3c566d394b";

const styles = (theme) => ({
  root: {
    flexGrow: 1,
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  title: {
    flexGrow: 1,
    display: 'none',
    fontFamily: "Lato",
    fontWeight: "bold",
    [theme.breakpoints.up('sm')]: {
      display: 'block',
    },
  },
  searchResultAnchor: {
    color: "black",
    textDecoration: "none"
  },
  '@media (min-width: 701px)': {
    search: {
      width: "300px !important",
    }
  },
  search: {
    position: 'relative',
    borderRadius: theme.shape.borderRadius,
    backgroundColor: fade(theme.palette.common.white, 0.15),
    '&:hover': {
      backgroundColor: fade(theme.palette.common.white, 0.25),
      boxShadow: "0 0 16px rgba(32,33,36,.12)",
      border: "1px solid #80868b"      
    },
    '&:focus': {
      boxShadow: "0 0 16px rgba(32,33,36,.12)",
      border: "1px solid #80868b"     
    },
    border: "1px solid #80868b",
    borderRadius: "24px",
    marginLeft: 0,
    width: '100%',
    [theme.breakpoints.up('sm')]: {
      marginLeft: theme.spacing(1),
      width: 'auto',
    },
    zIndex: 1000,
    backgroundColor: "white"
  },
  searchIcon: {
    padding: theme.spacing(0, 2),
    height: '100%',
    position: 'absolute',
    pointerEvents: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  inputRoot: {
    color: 'inherit',
    width: "100%"
  },
  inputInput: {
    padding: theme.spacing(1, 1, 1, 0),
    paddingLeft: `calc(1em + ${theme.spacing(4)}px)`,
    transition: theme.transitions.create('width'),
    width: '100%',
  },  
  rootSecondary: {
    backgroundColor: theme.palette.secondary.main,
    zIndex: 1000,
    borderBottom: "1px solid lightgray",
    [theme.breakpoints.down("sm")]: {
      borderBottom: "none",
    },
  },
  title: {
    cursor: "pointer",
    fontSize: 28,
    marginTop: 8,
  },
  blogButton: {
    padding: "11px 13px 11px",
    backgroundColor: "#3c9fe6",
    borderRadius: "8px",
    color: "white",
    margin: "0 20px",
    height: "15px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    cursor: "pointer"
  },
  subButton: {
    textTransform: "none",
  },
  spacer: {
    display: "inline-flex",
    flexGrow: 1,
  },
  listContainer: {
    maxWidth: "100%",
    width: "300px",
    maxHeight: "400px",
    overflowX: "hidden",
    position: "absolute",
    top: "30px",
    right: 239,
    zIndex: "10000",
    backgroundColor: "white",
    paddingLeft: 0,
    border: "1px solid black",
    borderTop: "none",
  },
  searchResult: {
    padding: "10px",
    '&:hover': {
      backgroundColor: "lightgray",
      cursor: "pointer"
    }
  },
  container: {
    position: "relative",
  },
  clearSearch: {
    position: "absolute",
    top: "12px",
    right: "14px",
    width: "14px",
    cursor: "pointer"
  },
  rightWrapper: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center"
  },
  homeLink: {
    marginLeft: "22px",
    textDecoration: "none",
    "&:visited": {
      color: "initial"
    }
  },
  "@media (max-width: 767px)": {
    rightWrapper: {
      flexDirection: "column"
    },
    container: {
      marginTop: "20px"
    },
    search: {
      margin: "25px 20px 0"
    },
    blogButton: {
      marginTop: "4px"
    },
    listContainer: {
      top: "100px",
      width: "100%",
      left: 0
    },
    buttonContainer: {
      padding: 0
    }
  },
  "@media (max-width: 700px)": {
    container: {
      marginBottom: "20px",
    },
    title: {
      margin: "auto",
      padding: "10px 0",
    },
    buttonRow: {
      justifyContent: "space-between",
      width: "100%",
    },
  },
});

class CustomAppBar extends React.Component {
  constructor(props) {
    super(props);
    this.state = { 
      companies: [], 
      filteredSearch: [], 
      searchTerm: "",
      resultsOpen: false,
    }
    this.myRef = React.createRef();
    this.searchRef = React.createRef();
  }

  async componentDidMount() {
    document.addEventListener("keydown", this.handleKeyPress, false);
    const results = await this.fetchData();
    this.setState({ companies: results, filteredSearch: results });
  }

  moveFocus() {
    const node = this.searchRef.current;
    node.addEventListener('keydown', function(e) {
      const active = document.activeElement;
      // const active = document.activeElement.firstChild;

      if(e.keyCode === 40 && active.nextSibling) {
        active.nextSibling.focus();
      }
      if(e.keyCode === 38 && active.previousSibling) {
        active.previousSibling.focus();
      }
    });    
  }

  fetchData = async () => {
    let snapshot = await firebase.firestore().collection("company-data").get();
    let companies = await Promise.all(
      snapshot.docs.map(async (doc) => {
        let data = doc.data();
        return data.companyName;
      })
    )

    return companies;
  }

  handleJoinCommunity = (e) => {
    if (
      window.location.hostname !== "localhost" &&
      window.location.hostname !== "127.0.0.1"
    ) {
      ReactGA.event({
        category: "Join Community Button Click",
        action: "Clicked Join Community Button",
        label: "AppBar.js",
      });
    }
    this.props.history.push("community");
  };

  getFilteredCompanies = (searchTerm) =>
    Object.assign([], this.state.companies).filter((name) => {
      let normalName = name.toLowerCase();
      let normalSearch = searchTerm.toLowerCase();
      let sub = normalName.substring(0, searchTerm.length);
      return (sub.indexOf(normalSearch) !== -1);
    })

  handleTextChange = (e) => {
    const searchTerm = e.target.value.trim();
    const filteredCompanies = this.getFilteredCompanies(searchTerm);
    this.setState({ filteredSearch: filteredCompanies, resultsOpen: true, searchTerm })
  }

  handleOnFocus = (e) => {
    e.stopPropagation();
    e.preventDefault();
    this.setState({ resultsOpen: true })

    const node = this.searchRef.current;
    node.addEventListener('keydown', function(e) {

      const active = document.activeElement;

      // if(e.keyCode === 40 && active.nextSibling) {
      //   active.nextSibling.focus();
      // }
      // if(e.keyCode === 38 && active.previousSibling) {
      //   active.previousSibling.focus();
      // }

      // const active = document.activeElement;
      // // const active = document.activeElement.firstChild;

      // if(e.keyCode === 40 && active.nextSibling) {
      //   active.nextSibling.focus();
      // }
      // if(e.keyCode === 38 && active.previousSibling) {
      //   active.previousSibling.focus();
      // }
    });    
  }
    

  openSubLink = () => {
    ReactGA.event({
      category: "Newsletter Sign Up",
      action: "Clicked Subscribe Button",
      label: "CustomAppBar.js",
    });
    return window.open(
      "https://lifeshack.us19.list-manage.com/subscribe/post?u=86fec8b983f1df74a98cb2fba&amp;id=3c566d394b"
    );
  };

  openLifeShack = () => {
    //window.open("https://remote.lifeshack.io")
    this.props.history.push("/");
  };

  openStartHere = () => {
    ReactGA.event({
      category: "View Blog",
      action: "Clicked Button in AppBar",
      label: "CustomAppBar.js",
    });
    return window.open("https://lifeshack.io/start-here");
  };


  handleKeyPress = (e) => {
    // escape key
    if (e.keyCode === 27) {
      if (this.state.searchTerm && this.state.resultsOpen) {
        this.setState({ searchTerm: "", filteredSearch: this.getFilteredCompanies("") })
      } else if (!this.state.searchTerm && this.state.resultsOpen) {
        this.setState({ resultsOpen: false });
        document.activeElement.blur()
      }
    }
  }

  render() {
    const {
      classes,
      secondary,
      third,
      disableMargins,
      backgroundColor,
      textColor,
      addBottomBorder = false,
      nosearch
    } = this.props;

    let rootStyle = { position: "relative", zIndex: 100 };
    if (backgroundColor) rootStyle.backgroundColor = backgroundColor;
    if (addBottomBorder) rootStyle.borderBottom = "1px solid lightgray";

    const clearText = (e) => {
      if (e) e.stopPropagation();
      this.setState({ searchTerm: "", filteredSearch: this.getFilteredCompanies("") })
    }

    const handleClose = () => this.setState({ resultsOpen: false });

    const renderList = () => {
      const handleClickLink = () => {
        handleClose();
        clearText();
      }

      const results = this.state.filteredSearch.map((item, idx) => {
        return (
          <Link to={`/company/${item}`} className={classes.searchResultAnchor}>
            <li className={classes.searchResult} tabIndex={idx} onClick={handleClickLink}>
              {item}
            </li>
          </Link>
        )
      })

      const NoResults = () => {
        return (
          <li className={classes.searchResult} tabIndex={-1}>
            No Matches
          </li>          
        )
      }

      if (resultsOpen) {
        return (
          <ul className={classes.listContainer} id="search-results" ref={this.myRef}>
            { this.state.filteredSearch.length ? results : <NoResults /> }
          </ul>
        )
      }
      return null;
    }

    const TransDiv = () => {
      const divStyle = {
        position: "fixed",
        left: 0,
        right: 0,
        bottom: 0,
        top: 0,
        backgroundColor: "#00000042",
        zIndex: 1
      }
      return <div style={divStyle} onClick={handleClose}></div>
    }

    const { resultsOpen } = this.state;

    const renderPrimary = () => (
      <>
        <Link to="/" className={classes.homeLink}>
          <Logo />
        </Link>
        <Mobile>
          <Link to="/blog" style={{ textDecoration: "none" }}>
            <a 
              // href={subscribeLink}
              onClick={this.openSubLink}
              style={{ textDecoration: "none" }}
              target="_blank"
              rel="noopener noreferrer"
            >
              <div className={classes.blogButton}>Subscribe</div>
            </a>                 
            {/* <div className={classes.blogButton}>Blog</div>           */}
          </Link>
        </Mobile>
        <NotMobile>
          <div className={classes.rightWrapper}>
            {
              !nosearch ? (
                <div className={classes.search}>
                  <div className={classes.searchIcon}>
                    <SearchIcon  />
                  </div>
                  <InputBase
                    placeholder="Search…"
                    classes={{
                      root: classes.inputRoot,
                      input: classes.inputInput,
                    }}
                    onChange={this.handleTextChange}
                    value={this.state.searchTerm}
                    inputProps={{ 'aria-label': 'search' }}
                    onFocus={this.handleOnFocus}
                    onClick={(e) => e.stopPropagation()}
                    ref={this.searchRef}
                  />
                  {this.state.searchTerm.length ? <img src={CloseIcon} className={classes.clearSearch} onClick={clearText} /> : null}
                </div>
              ) : null
            }
            <>
              <Link to="/blog" style={{ textDecoration: "none" }}>
                <div className={classes.blogButton} style={{ color: "#000", border: "1px solid black", background: "none" }}>Blog</div>
              </Link>
              <a 
                href={subscribeLink}
                style={{ textDecoration: "none" }}
                target="_blank"
                rel="noopener noreferrer"
              >
                <div className={classes.blogButton}>Subscribe</div>
              </a>              
            </>
          </div>
        </NotMobile>
        <Mobile>
          {
            !nosearch ? (
              <div className={classes.search}>
                <div className={classes.searchIcon}>
                  <SearchIcon  />
                </div>
                <InputBase
                  placeholder="Search…"
                  classes={{
                    root: classes.inputRoot,
                    input: classes.inputInput,
                  }}
                  onChange={this.handleTextChange}
                  value={this.state.searchTerm}
                  inputProps={{ 'aria-label': 'search' }}
                  onFocus={this.handleOnFocus}
                  onClick={(e) => e.stopPropagation()}
                  ref={this.searchRef}
                />
                {this.state.searchTerm.length ? <img src={CloseIcon} className={classes.clearSearch} onClick={clearText} /> : null}
              </div>
            ) : null
          }
        </Mobile>
      </>      
    )    

    return (
      <div 
        onClick={handleClose}
      >
        <div
          className={secondary ? classes.rootSecondary : classes.root}
          style={rootStyle}
        >
          <Toolbar disableGutters={disableMargins}>
            <Container className={classes.buttonContainer} maxWidth="lg" style={disableMargins ? { margin: 0 } : {}}>
              <Grid
                className={classes.container}
                container
                justify="space-between"
                style={{ padding: 0 }}
              >
                {renderPrimary()}
                {renderList()}
              </Grid>
            </Container>
          </Toolbar>
        </div>
        { resultsOpen && <TransDiv /> }
      </div>
    );
  }
}

export default withRouter(withStyles(styles)(CustomAppBar));
